import EzSimpleDropdown from '@/components/ui/Dropdown/EzSimpleDropdown.vue';

export { default } from './EzDropdown.vue';
export { EzSimpleDropdown };
